import { BaseModel, type RelationConfig } from './base';

export class ReservationStatusTypeOptionsColor extends BaseModel {}

export class ReservationStatusTypeOptions extends BaseModel {
  colors!: ReservationStatusTypeOptionsColor[];

  static override relations(): RelationConfig {
    return {
      colors: { type: ReservationStatusTypeOptionsColor },
    };
  }
}

export class ReservationStatusType extends BaseModel {
  idReservationStatusType!: number;
  name!: string;
  options!: ReservationStatusTypeOptions;

  static override relations(): RelationConfig {
    return {
      options: { type: ReservationStatusTypeOptions },
    };
  }

  override objectID(): string | null {
    return this.idReservationStatusType?.toString() ?? null;
  }
}
